import React from 'react';
import styled from '@benzinga/themetron';

import { NBSP } from './info';
import { isNil } from '@benzinga/utils';
import { PermissionedComponent } from '@benzinga/user-context';
import { useQuoteSubscriptionDetail } from '@benzinga/quotes-manager-hooks';
import { StockSymbol } from '@benzinga/session';

interface Props {
  symbol: StockSymbol;
}

export const QuoteInfo: React.FC<Props> = props => {
  const { currency = null, delayedMinutes = null, source = null } = useQuoteSubscriptionDetail(props.symbol) ?? {};
  const showUpSellNag = !isNil(delayedMinutes) && source === 'CTA Delayed';

  return (
    <>
      {!isNil(delayedMinutes) && `${delayedMinutes} Minutes Delayed | `}
      {!isNil(source) && (
        <>
          {source}
          {showUpSellNag && (
            <PermissionedComponent resourceName="quote-info" supplementalOrAccess={showUpSellNag}>
              <NoWrapAnchor>Get Real-Time</NoWrapAnchor>
            </PermissionedComponent>
          )}
          {'|'}
        </>
      )}
      {NBSP}
      {currency}
    </>
  );
};

const NoWrapAnchor = styled.a<{ href?: string }>`
  white-space: nowrap;
`;
